import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://qingyakeji-tutor.oss-cn-beijing.aliyuncs.com/yagw/img/index/log.png" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("网站首页")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 关于我们 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("产品中心")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("应用领域")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("生产实力")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("联系我们")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_menu, {
        "default-active": _ctx.$route.path,
        class: "el-menu-demo",
        mode: "horizontal",
        "text-color": "#020202",
        "active-text-color": "#fff",
        router: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/about" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/production" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/service" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/strength" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/contact" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ])
  ]))
}